import styled from 'styled-components';
import { StyledPanelContainer } from '../PanelContainer';

const StyledEntitySelectorContainer = styled(StyledPanelContainer)`
	left: 40px;
	top: 40px;
`;

export { StyledEntitySelectorContainer };
